import { render, staticRenderFns } from "./TextureList.vue?vue&type=template&id=5527ac4e&scoped=true"
import script from "./TextureList.vue?vue&type=script&lang=js"
export * from "./TextureList.vue?vue&type=script&lang=js"
import style0 from "./TextureList.vue?vue&type=style&index=0&id=5527ac4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527ac4e",
  null
  
)

export default component.exports